//* 绘图库
import Konva from "konva";
//* 组件库
import { utility } from "various-ui";
//* 工具库
import { Draw } from "@/assets/js";
//* 组件属性
import type { ModuleExpression } from "../../../index";

//* 可视化数据类型
export interface VisualData {
    size: number;
    rect: number;
    offset: number;
    spacing: number;
    divisionX: number;
    divisionY: {
        up: Draw.DividingRule;
        down?: Draw.DividingRule;
        value: number;
        ratio: number;
        decimals: number;
    };
}

//* 坐标系比对（确定以哪个坐标系为基准绘图）
const axisComparison = (max: number, min: number) => {
    //* 计算刻度尺
    const divisionsMax = Draw.dividingRule(max, [3]); //* 刻度尺
    //* 不存在负值坐标轴, 则直接返回
    if (min >= 0) {
        return {
            decimals: divisionsMax.decimals,
            ratio: utility.divide(divisionsMax.scales.length * 96, divisionsMax.value),
            value: divisionsMax.value,
            up: divisionsMax,
        };
    }

    //* 计算刻度尺
    const divisionsMin = Draw.dividingRule(Math.abs(min), [3]); //* 刻度尺

    //* 检测比对的默认值与相对值
    const config = { default: divisionsMax, comparison: divisionsMin };
    if (divisionsMin.value > divisionsMax.value) {
        config.default = divisionsMin;
        config.comparison = divisionsMax;
    }

    return {
        up: config.default,
        value: config.default.value,
        ratio: utility.divide(config.default.scales.length * 96, config.default.value),
        decimals: config.default.decimals,
        down: {
            ...config.default,
            scales: config.default.scales.filter((scale) => {
                return scale <= config.comparison.value + utility.divide(config.default.value, config.default.number);
            }),
        },
    };
};

//* 可视化数据处理
export const disposeVisualData = (data: ModuleExpression[], option: { size: number; offset: number; spacing: number }) => {
    //* 统计最值
    const maxValue = data.reduce((accumulator, currentValue) => Math.max(currentValue.value, accumulator), 0);
    const minValue = data.reduce((accumulator, currentValue) => Math.min(currentValue.value, accumulator), 0);
    //* 数据初始化
    const size = option.size - option.spacing * 2;
    //* 坐标轴比对
    const divisions = axisComparison(maxValue, minValue);
    //* 峰值的文本
    const divisionText = new Konva.Text({ text: divisions.value.toString(), fontSize: 12, fontFamily: "Noto Sans CJK Regular" });
    const divisionTextSize = divisionText.getTextWidth();
    const sizeText = divisionTextSize > 24 ? divisionTextSize + 8 : 32;
    //* 根据内容分配柱子是否缩小
    if (size - option.offset - sizeText >= data.length * 28) {
        return {
            size: 20,
            rect: Math.ceil(sizeText),
            offset: option.offset,
            spacing: option.spacing,
            divisionX: (size - option.offset - sizeText - data.length * 20) / data.length,
            divisionY: divisions,
        };
    } else {
        return {
            size: (size - option.offset - sizeText - data.length * 8) / data.length,
            rect: Math.ceil(sizeText),
            offset: option.offset,
            spacing: option.spacing,
            divisionX: 8,
            divisionY: divisions,
        };
    }
};
